import { Loader, MiniTile, DeltaBadge, EmployeeTable, useReport, ExportCsvButton } from "../shared";

export const WagesByEmployeeSection = ({ filter }) => {
  const [data, loading, prevData] = useReport("/reports/wages-by-employee", filter, false, {
    isWagesEndpoint: true,
  });
  if (loading) return <Loader />;
  if (!data) return null;
  return (
    <div className="space-y-3" data-testid="wages-section">
      <div className="flex justify-end">
        <ExportCsvButton path="/reports/wages-by-employee/export.csv" filter={filter} isSingleDay={false} inclusiveEnd testId="export-wages-csv" />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <MiniTile
          label="Total Wages"
          value={`$${data.total_wages.toFixed(2)}`}
          testId="wages-total-wages"
          extra={prevData ? <DeltaBadge current={data.total_wages} previous={prevData.total_wages} /> : null}
        />
        <MiniTile
          label="Total Tips"
          value={`$${data.total_tips.toFixed(2)}`}
          tone="text-accent"
          testId="wages-total-tips"
          extra={prevData ? <DeltaBadge current={data.total_tips} previous={prevData.total_tips} /> : null}
        />
        <MiniTile
          label="Total Pay"
          value={`$${data.total_pay.toFixed(2)}`}
          valueClass="text-2xl font-mono font-semibold"
          testId="wages-total-pay"
          extra={prevData ? <DeltaBadge current={data.total_pay} previous={prevData.total_pay} /> : null}
        />
      </div>
      <EmployeeTable
        rows={data.employees}
        columns={[
          { key: "name", label: "Employee", fmt: (v) => v },
          { key: "role", label: "Role", fmt: (v) => v },
          { key: "hours", label: "Hours", fmt: (v) => v.toFixed(2), align: "right" },
          { key: "wages", label: "Wages", fmt: (v) => `$${v.toFixed(2)}`, align: "right" },
          { key: "tips", label: "Tips", fmt: (v) => `$${v.toFixed(2)}`, align: "right", accent: true },
          { key: "total_pay", label: "Total Pay", fmt: (v) => `$${v.toFixed(2)}`, align: "right", bold: true },
        ]}
        testIdPrefix="wages-row"
        emptyText="No clock-in or sales in this window."
      />
    </div>
  );
};
